module.exports = __webpack_public_path__ + "img/2.a94a1f58.png";